import { X } from 'lucide-react';

/**
 * Dismissible banner shown at the top of the Dashboard when at least one
 * unpaired Vizio TV is detected on the local network.
 *
 * Modeled on TraktPrompt — same dismissible card pattern, but uses Qude's
 * cyan/purple brand gradient instead of red.
 *
 * Tap "Pair" → parent opens VizioPairingModal with this TV's IP.
 * Tap X → parent saves dismissal in sessionStorage, hides banner.
 */
export default function VizioPairingPrompt({ tvName, ipAddress, onPair, onDismiss }) {
  return (
    <div
      className="relative p-5 rounded-2xl border border-violet-500/30 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #0a0518 0%, #0a0a0a 100%)' }}
    >
      <button
        onClick={onDismiss}
        className="absolute top-3 right-3 p-1 text-neutral-600 hover:text-white transition-colors"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-4">
        <div
          className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{
            background: 'rgba(124, 58, 237, 0.15)',
            border: '1px solid rgba(124, 58, 237, 0.3)',
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            style={{ color: '#a78bfa' }}
          >
            <rect x="2" y="4" width="20" height="14" rx="2" />
            <path d="M8 22h8" />
            <path d="M12 18v4" />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-black text-white mb-1" style={{ fontFamily: 'Outfit' }}>
            Connect your TV
          </p>
          <p className="text-xs text-neutral-400 leading-relaxed mb-3">
            We found {tvName ? <strong className="text-white">{tvName}</strong> : 'your Vizio'} on your network.
            Pair it so Qude can see what's playing.
          </p>
          <div className="flex items-center gap-2 flex-wrap">
            <button
              onClick={() => onPair?.(ipAddress, tvName)}
              className="flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold text-white transition-all hover:opacity-90"
              style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #4A9EFF 100%)' }}
            >
              Pair TV
            </button>
            <button
              onClick={onDismiss}
              className="text-xs text-neutral-500 hover:text-neutral-300 transition-colors px-2 py-2"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
